import { LdButton } from "@liquid/react";
import { ErrorCard, StyledPage } from "@src/components";

const AppError = () => {
  return (
    <StyledPage>
      <ErrorCard
        title="Sorry, something went wrong."
        subtitle="Please try to refresh the page"
      >
        <LdButton onClick={() => window.location.reload()}>Refresh</LdButton>
      </ErrorCard>
    </StyledPage>
  );
};

export { AppError };
